import React from 'react';

const LocationBenefits = ({benefits, setBenefits}) => {

  const units = ['Km'];

  const addBenefit = () => {
    setBenefits([...benefits, { name: '', value: '', unit: 'Km' }]);
  };

  const removeBenefit = (index) => {
    const updated = benefits.filter((_, i) => i !== index);
    setBenefits(updated);
  };

  const updateBenefit = (index, field, value) => {
    const updated = [...benefits];
    updated[index][field] = value;
    setBenefits(updated);
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <button type="button" className="btn btn-outline-success btn-sm" onClick={addBenefit}>
          + Add new
        </button>
      </div>

      {benefits.map((benefit, index) => (
        <div className="row align-items-center mb-2" key={index}>
          <div className="col-md-4">
            <input
              type="text"
              className="form-control"
              placeholder="Label"
              value={benefit.name}
              onChange={(e) => updateBenefit(index, 'name', e.target.value)}
            />
          </div>
          <div className="col-md-3">
            <input
              type="text"
              className="form-control"
              placeholder="Value"
              value={benefit.value}
              onChange={(e) => updateBenefit(index, 'value', e.target.value)}
            />
          </div>
          <div className="col-md-3">
            <select
              className="form-select"
              value={benefit.unit}
              onChange={(e) => updateBenefit(index, 'unit', e.target.value)}
            >
              {units.map((unit) => (
                <option key={unit} value={unit}>
                  {unit}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-2 text-end">
            <button
              type="button"
              className="btn btn-danger btn-sm"
              onClick={() => removeBenefit(index)}
            >
              Remove
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LocationBenefits;
